import React from 'react';
import PropTypes from 'prop-types';
import { FontIcon } from 'material-ui';
import ActionButton from './ActionButton';

const ActionIconButton = ({ action, icon, color }) => (
  <ActionButton action={action} style={{ minWidth: 0, padding: '0 6px' }}>
    <FontIcon className="material-icons" style={{ paddingTop: '6px', color }}>{icon}</FontIcon>
  </ActionButton>
);

ActionIconButton.propTypes = {
  action: PropTypes.func,
  icon: PropTypes.string,
  color: PropTypes.string,
};

ActionIconButton.defaultProps = {
  color: '#727272',
};

export default ActionIconButton;



// WEBPACK FOOTER //
// ./src/components/ActionIconButton.js